import { TranslateService } from "@ngx-translate/core";

import { Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  private translate = inject(TranslateService);

  constructor() {
    super();
    this.translateLabels();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    const of = this.translate.instant("Paginator.Of");
    if (length === 0 || pageSize === 0) {
      return "0 " + of + " " + length;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return startIndex + 1 + " - " + endIndex + " " + of + " " + length;
  };

  private translateLabels() {
    this.itemsPerPageLabel = this.translate.instant("Paginator.ItemsPerPage");
    this.nextPageLabel = this.translate.instant("Paginator.NextPage");
    this.previousPageLabel = this.translate.instant("Paginator.PreviousPage");
    this.firstPageLabel = this.translate.instant("Paginator.FirstPage");
    this.lastPageLabel = this.translate.instant("Paginator.LastPage");
    this.changes.next();
  }
}
